import PseudonymWarner from '@intercom/embercom-composer/components/pseudonym-warner';
export default PseudonymWarner;
